<template>
  <div class="checkbox-group-container form-main">
    <div class="checkbox-group-inner">
      <div v-for="formField in formData.options" v-bind:key="formField.id">
        <label
          :class="{ checked: formData.selected.includes(formField) }"
          class="checkbox-group is-button"
        >
          <span class="ml-2">{{ formField }}</span>
          <input
            type="checkbox"
            name="tab-1"
            :value="formField"
            v-model="formData.selected"
          />
          <span class="checkmark not-radio"></span>
        </label>
      </div>
    </div>
    <p class="mb-0" style="font-size:16px;line-height:14px;">Mehrfachantworten möglich</p>
  </div>
</template>
<script>
export default {
  name: "CheckboxGroup",
  props: {
    formData: Object,
  },
};
</script>